import List from 'list.js';

jQuery(function () {
    const $container = jQuery('#job-table');

    // Only initialize if the container exists
    if ($container.length) {
        const options = {
            valueNames: ['job', 'company', 'location']
        };

        const userList = new List('job-table', options);

        const searchText = jQuery('input.search').val() || '';

        if (searchText && typeof userList.search === 'function') {
            userList.search(searchText);
        }
    }
});
